import axios from "../axios";

const storeCommentToResolution = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/comment`, form)
        .then(response => response.data)
}

const returnResolution = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/return`, form)
        .then(response => response.data)
}

const approveResolution = (id) => {
    return axios.post(`/docflow/resolutions/${id}/to-approve`)
        .then(response => response.data)
}

const answerApprove = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/to-approve-new`, form)
        .then(response => response.data)
}

const returnSignResolution = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/return-sign`, form)
        .then(response => response.data)
}

const approveSignResolution = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/to-approve-sign`, form)
        .then(response => response.data)
}

const answerApproveSign = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/to-approve-sign-new`, form)
        .then(response => response.data)
}

const additionalApproveSignResolution = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/additional-to-approve-sign`, form)
        .then(response => response.data)
}

const directorApproveSignResolution = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/approve-sign`, form)
        .then(response => response.data)
}

const getApplicationResolutions = (id) => {
    return axios.get(`/docflow/applications/${id}/resolutions`)
        .then(response => response.data);
}

const getResolution = (id) => {
    return axios.get(`/docflow/resolutions/${id}`)
        .then(response => response.data);
}

const assignCurator = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/assign-curator`, form)
        .then(response => response.data)
}

const reassignCurator = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/re-assign-curator`, form)
        .then(response => response.data)
}

const addExecutors = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/add-employments`, form)
        .then(response => response.data)
}

const distributeResolution = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/distribution`, form)
        .then(response => response.data)
}

const answerResolution = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/answer`, form)
        .then(response => response.data)
}

const acceptInProcessRemarksUpdate = (id) => {
    return axios.post(`/docflow/resolutions/${id}/accept-in-process-remarks-update`)
        .then(response => response.data)
}

const rejectInProcessRemarksUpdate = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/reject-in-process-remarks-update`, form)
        .then(response => response.data)
}

const signResolutionAnswer = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/answer-sign`, form)
        .then(response => response.data)
}

const answerReturnResolution = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/answer-return`, form)
        .then(response => response.data)
}

const answerReturnFromParentResolution = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/answer-return-from-parent`, form)
        .then(response => response.data)
}

const confirmResolutionAnswerReview = (id) => {
    return axios.post(`/docflow/resolutions/${id}/answer-review-confirm`)
        .then(response => response.data)
}

const confirmResolutionAnswer = (id) => {
    return axios.post(`/docflow/resolutions/${id}/answer-confirm`)
        .then(response => response.data)
}

const confirmAgreementRemarks = (id) => {
    return axios.post(`/docflow/resolutions/${id}/agreement-remarks-confirm`)
        .then(response => response.data)
}

const confirmAdditionalAgreementRemarks = (id) => {
    return axios.post(`/docflow/resolutions/${id}/additional-agreement-remarks-confirm`)
        .then(response => response.data)
}

const getChildResolutionsFiles = (id) => {
    return axios.get(`/docflow/resolutions/${id}/children-answer-files`)
        .then(response => response.data);
}

const defaultSigners = (id) => {
    return axios.get(`/docflow/resolutions/${id}/executor-list`)
        .then(response => response.data);
}

const defaultApproveSigners = (id) => {
    return axios.get(`/docflow/resolutions/${id}/default-signers`)
        .then(response => response.data);
}

const conclusionResolution = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/conclusion`, form)
        .then(response => response.data)
}

const generateConclusionFile = (id) => {
    return axios.post(`/docflow/resolutions/${id}/conclusion/generate-file`)
        .then(response => response.data)
}

const remarkResolution = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/remarks`, form)
        .then(response => response.data)
}

const confirmResolutionConclusion = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/conclusion-confirm`, form)
        .then(response => response.data)
}

const signResolutionConclusion = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/conclusion-sign`, form)
        .then(response => response.data)
}

const signResolutionRemark = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/remarks-sign`, form)
        .then(response => response.data)
}

const agreementRemarks = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/agreement-remarks`, form)
        .then(response => response.data)
}

const signResolutionConclusionByAccountant = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/conclusion-accountant-sign`, form)
        .then(response => response.data)
}

const reassignResponsible = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/re-assign`, form)
        .then(response => response.data)
}

const deleteEmployee = (resolutionId, employeeId) => {
    return axios.post(`/docflow/resolutions/${resolutionId}/delete-employment/${employeeId}`)
        .then(response => response.data)
}

const getAnswer = (applicationId, resolutionId) => {
    return axios.get(`/docflow/applications/${applicationId}/resolutions/${resolutionId}/get-last-answer`)
        .then(response => response.data.data);
}

const getChildrenAnswers = (id) => {
    return axios.get(`/docflow/resolutions/${id}/get-child-answers`)
        .then(response => response.data.data);
}

const updateDeadline = (id, form) => {
    return axios
        .post(`docflow/resolutions/${id}/agreement-deadline-update`, form)
        .then(response => response.data)
}

export const getDefaultSigners = (id) => {
    return axios.get(`/docflow/resolutions/${id}/remarks/default-signers`)
        .then(response => response.data);
}

export const defaultAgreementRemarksApproveSigners = (id) => {
    return axios.get(`/docflow/resolutions/${id}/agreement/remarks/default-signers`)
        .then(response => response.data);
}

export default {
    defaultAgreementRemarksApproveSigners,
    answerApproveSign,
    storeCommentToResolution,
    defaultApproveSigners,
    approveResolution,
    answerApprove,
    returnResolution,
    approveSignResolution,
    additionalApproveSignResolution,
    returnSignResolution,
    getApplicationResolutions,
    getResolution,
    directorApproveSignResolution,
    assignCurator,
    reassignCurator,
    distributeResolution,
    answerResolution,
    signResolutionAnswer,
    answerReturnResolution,
    answerReturnFromParentResolution,
    confirmResolutionAnswerReview,
    confirmResolutionAnswer,
    confirmAgreementRemarks,
    confirmAdditionalAgreementRemarks,
    getChildResolutionsFiles,
    defaultSigners,
    conclusionResolution,
    generateConclusionFile,
    confirmResolutionConclusion,
    signResolutionConclusion,
    addExecutors,
    reassignResponsible,
    deleteEmployee,
    signResolutionConclusionByAccountant,
    remarkResolution,
    signResolutionRemark,
    agreementRemarks,
    getAnswer,
    getChildrenAnswers,
    updateDeadline,
    getDefaultSigners,
    acceptInProcessRemarksUpdate,
    rejectInProcessRemarksUpdate,
};
